import React from "react";
import module from "./CommonInput.module.css";
import { TextField } from "@mui/material";

const Password = () => {
  return (
    <div className={module.textfield}>
      <div>
        <span className={module.label}>パスワード</span>{" "}
        <span className={module.passwordLabel}>
          {"("}半角英数6文字以上{")"}
        </span>
      </div>
      <TextField id="password" variant="outlined" type="password" fullWidth />
    </div>
  );
};

export default Password;
